import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import Profile from "../components/Profile";

const ProfilePage = () => {
  return (
    <>
      <Preloader />

      <HeaderOne />

      <Profile />

      <FooterOne />
    </>
  );
};

export default ProfilePage;
